import { handleErrors } from './ErrorActions';
import * as userDataApi from '../api/user-data';

export const FETCH_RECENT_EVENTS = 'RecentEventsActions/FETCH_RECENT_EVENTS';
export const FETCH_RECENT_EVENTS_SUCCESS = 'RecentEventsActions/FETCH_RECENT_EVENTS_SUCCESS';
export const FETCH_RECENT_EVENTS_FAILURE = 'RecentEventsActions/FETCH_RECENT_EVENTS_FAILURE';

export const fetchRecentEventsSuccess = (data) => ({
  type: FETCH_RECENT_EVENTS_SUCCESS,
  payload: { data },
});

export const fetchRecentEventsFailure = (error) => ({
  type: FETCH_RECENT_EVENTS_FAILURE,
  payload: { error },
});

export const fetchRecentEvents = () => async (dispatch) => {
  dispatch({
    type: FETCH_RECENT_EVENTS,
  });

  try {
    const apiData = await userDataApi.getRecentEvents();

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(fetchRecentEventsSuccess(apiData.recentEvents));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchRecentEvents() failed: ${JSON.stringify(error)}`);
    dispatch(fetchRecentEventsFailure(error));
    dispatch(handleErrors(error));
  }
};

export const addRecentEvent = (params) => async (dispatch) => {
  try {
    const apiData = await userDataApi.addRecentEvent(params);

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`addRecentEvent() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};
